module.exports = __webpack_public_path__ + "img/ilifestyle_screen04.3bc0c4b7.png";